import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const CustomerPublicLayout = loadable(
  () => import('./customerPublic.layout'),
  {
    fallback: <FullPageLoader />,
  }
);
